import Revenues_RevenuesPage from "@Quest/Revenues/Pages/RevenuesPage.vue";

export const routes = [
    {
        path: "/enterprise/revenues/:workspaceId/:strategyId",
        component: Revenues_RevenuesPage
    },
]
